// extracted by mini-css-extract-plugin
export default {"productTypeRow":"ViewTypeSection_productTypeRow__NABbG","numProducts":"ViewTypeSection_numProducts__OtYmf","productRowList":"ViewTypeSection_productRowList__1VSPw"};